function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P4Landfill = function P4Landfill(_ref) {
  var page = _ref.page;
  var thisPage = 6;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    p4Landfill = _useState2[0],
    setP4Landfill = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    p4Arrows = _useState4[0],
    setP4Arrows = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    percent = _useState6[0],
    setPercent = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pTimer = _useState8[0],
    setPTimer = _useState8[1];
  var clearTimers = function clearTimers() {
    if (p4Landfill) clearTimeout(p4Landfill);
    if (p4Arrows) clearTimeout(p4Arrows);
    if (pTimer) clearTimeout(pTimer);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    if (pTimer) clearTimeout(pTimer);
    if (page === thisPage || page === thisPage + 1 || page === thisPage + 2) {
      if (page === thisPage) {
        setPercent(0);
        $('.p4-landfill').removeClass('p4-landfill__5');
        $('.p4-landfill').removeClass('p4-landfill__6');
        $('.p4-landfill__arrows').removeClass('p4-landfill__arrows--active');
        setP4Landfill(setTimeout(function () {
          $('.p4-landfill').addClass('p4-landfill__active');
        }, 3500));
      }
      if (page === thisPage + 1) {
        setPercent(1);
        if (p4Landfill) clearTimeout(p4Landfill);
        $('.p4-landfill').addClass('p4-landfill__5');
        $('.p4-landfill').addClass('p4-landfill__5');
        setP4Arrows(setTimeout(function () {
          $('.p4-landfill__arrows').addClass('p4-landfill__arrows--active');
        }, 500));
      } else {
        $('.p4-landfill').removeClass('p4-landfill__5');
        $('.p4-landfill__arrows').removeClass('p4-landfill__arrows--active');
      }
      if (page === thisPage + 2) {
        if (p4Landfill) clearTimeout(p4Landfill);
        setPercent(90);
        $('.p4-landfill').addClass('p4-landfill__6');
      } else {
        $('.p4-landfill').removeClass('p4-landfill__6');
      }
    } else {
      setPercent(0);
      clearTimers();
      $('.p4-landfill').removeClass('p4-landfill__active');
      $('.p4-landfill').removeClass('p4-landfill__5');
      $('.p4-landfill').removeClass('p4-landfill__6');
      $('.p4-landfill__arrows').removeClass('p4-landfill__arrows--active');
    }
  }, [page]);
  useEffect(function () {
    if (page === thisPage) {
      if (pTimer) clearTimeout(pTimer);
      setPercent(0);
      return;
    } else if (page === thisPage + 2) {
      setPercent(90);
      if (pTimer) clearTimeout(pTimer);
      return;
    }
    if (percent === 0 || percent >= 90) return;
    if (pTimer) clearTimeout(pTimer);
    setPTimer(function () {
      setTimeout(function () {
        setPercent(percent + 1);
      }, 75);
    });
  }, [percent]);
  return /*#__PURE__*/React.createElement("div", {
    className: "p4-landfill"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/recycled-landfill.png",
    className: "p4-landfill__green",
    style: {
      opacity: percent / 100
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/recycling-circle-2@3x.png",
    className: "p4-landfill__arrows",
    style: {
      opacity: percent / 100
    }
  }));
};
export default P4Landfill;

// const Counter = ({ percent }) => {

// 	const nr = percent.toString();

// 	const first = nr.length === 1 ? nr : nr[1];
// 	const second = nr.length === 1 ? null : nr[0];

// 	return (
// 		<div className='p4-counter'>

// 			{ second &&
// 				<img
// 					src={`/public/images/our-purpose/p4/${second}@3x.png`}
// 					className={`${second === '1' ? 'p4-counter__nr1' : 'p4-counter__nr1'}`}
// 				/>
// 			}

// 			<img
// 				src={`/public/images/our-purpose/p4/${first}@3x.png`}
// 				className={`${first === '1' ? 'p4-counter__nr2' : 'p4-counter__nr2'}`}
// 			/>

// 			<img
// 				src='/public/images/our-purpose/p4/invalid-name@3x.png'
// 				className='p4-counter__nr3'
// 			/>
// 		</div>
// 	);
// };